
import { FieldControl } from '@signature-it/ngx-generic/enums';
import {SelectField} from "./select";

export class DropdownField extends SelectField {
    controlType = FieldControl.DROPDOWN;
    // dynamicOptions = true;

}
